import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_DOMAINS_DAILY_STATS } from '../../../../query/monitor/data/sources/keys';
import { getDomainsDailyStats } from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';
import { DomainsDailyStatsResponse } from '../../../../../models/monitor/data/sources/DomainsDailyStatsResponse';
import { MonitorPeriod } from '../../../../../types/monitor/MonitorPeriod';

export const useGetDomainsDailyStats = (
  projectId: number | null,
  chatType: ChatType | null,
  period: MonitorPeriod | null,
  from: Date | null,
  to: Date | null,
  domain: string[] | undefined | null,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId && !!chatType && !!period && !!from && !!to && domain !== null;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: domainsDailyStats,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<DomainsDailyStatsResponse>({
    queryKey: [GET_DOMAINS_DAILY_STATS, projectId, chatType, period, fromTimestamp, toTimestamp, domain, monitorPromptIds, filterMonitorTypes],
    queryFn: () => getDomainsDailyStats(projectId!, chatType!, period!, from, to, domain, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    domainsDailyStats: queryEnabled ? domainsDailyStats ?? {} : ({} as DomainsDailyStatsResponse),
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [
          GET_DOMAINS_DAILY_STATS,
          projectId,
          chatType,
          period,
          fromTimestamp,
          toTimestamp,
          domain,
          monitorPromptIds,
          filterMonitorTypes,
        ],
        refetchType: 'active',
      }),
  };
};
